import Vue from "vue"
import VueRouter from "vue-router"
import BlueHPNHome from "../views/home.vue"
import BlueHPNEvaluation from "../views/quiz.vue"

Vue.use(VueRouter)

const routes = [
  {
      path: "/",
      name: "Blue HPN Home",
      component: BlueHPNHome,
      meta: {
            title: "Blue HPN Home"
      }
  },
  {
      path: "/evaluation/",
      name: "Blue HPN Evaluation Quiz",
      component: BlueHPNEvaluation,
      meta: {
            title: "Blue HPN Evaluation Quiz"
      }
  }
]

const router = new VueRouter({
      mode: "history",
      base: "ny",
      routes
})
router.afterEach((to) => {
      if (to.meta && to.meta.title) {
            document.title = to.meta.title || "Blue HPN"
      }
})

export default router
